class Template {
  constructor (options) {
    this.container = options.container
    this.options = options.options
    this.init()
  }

  init () {
    this.time = this.container.querySelector('.testv__audio__player__time')
    this.ptime = this.container.querySelector('.testv__audio__player__ptime')
    this.dtime = this.container.querySelector('.testv__audio__player__dtime')
    this.barWrap = this.container.querySelector('.testv__audio__player__bar__wrapper')
    this.button = this.container.querySelector('.testv__audio__player__btn__play')
    this.played = this.container.querySelector('.testv__audio__player__played')
    this.loaded = this.container.querySelector('.testv__audio__player__loaded')
    this.thumb = this.container.querySelector('.testv__audio__player__thumb')
    this.volumeWrap = this.container.querySelector('.testv__audio__player__volume__wrapper')
    this.volume = this.container.querySelector('.testv__audio__player__volume')
    this.volumeBar = this.container.querySelector('.testv__audio__player__volume__bar')
    this.volumeButton = this.container.querySelector('.testv__audio__player__volume__wrapper button')
    this.volumeBarWrap = this.container.querySelector('.testv__audio__player__volume__bar__wrapper')
    this.seekForward = this.container.querySelector('.testv__audio__player__btn__forward')
    this.seekBackward = this.container.querySelector('.testv__audio__player__btn__backward')
    this.nodeList = this.container.querySelectorAll('.testv__audio__player__node__wrapper')
    // this.speedWrap = this.container.querySelector('.testv__audio__player__speed__wrapper')
    // this.speedList = this.container.querySelectorAll('.testv__audio__player__speed-item')
    // this.speedButton = this.container.querySelector('.testv__audio__player__speed-button')
  }
}

export default Template
